import moment from 'moment';

export function compareProjectIdWithRouteParamProjectId(projectId: string | number, routeParamProjectId?: string): boolean {

    if (!routeParamProjectId)
        return false;

    routeParamProjectId = determineIfPublisherProjectId(routeParamProjectId);

    return projectId.toString().toLocaleLowerCase() === routeParamProjectId?.toLocaleLowerCase();
}

export function getToolUrl(toolId: string, toolProjectId: string | number, isDevSite: boolean, gameEnvironmentId?: string) {

    switch (toolId.toLocaleLowerCase()) {
        case 'publisher':
            return `${isDevSite ? 'https://publisher-yakoffice-dev.web.app' : 'https://publisher.yakoffice.app'}/projects/${toolProjectId}/versions/current/categories`;
        case 'players':
            return `${isDevSite ? 'https://players-yakoffice-dev.web.app' : 'https://players.yakoffice.app'}/projects/${toolProjectId}/${gameEnvironmentId ? gameEnvironmentId : 'development'}/player`;
        case 'deletionrequests':
            return `${isDevSite ? 'https://players-yakoffice-dev.web.app' : 'https://players.yakoffice.app'}/projects/${toolProjectId}/${gameEnvironmentId ? gameEnvironmentId : 'development'}/player/deletion-requests`;
        case 'builds':
            return `${isDevSite ? 'https://builds-yakoffice-dev.web.app' : 'https://builds.yakoffice.app'}/projects/${toolProjectId}/builds`;
        case 'sessions':
            return `${isDevSite ? 'https://sessions-yakoffice-dev.web.app' : 'https://sessions.yakoffice.app'}/projects/ppf/production/sessions`;
    }
}

export function getProjectUrl(toolId: string, toolProjectId: string | number, gameEnvironmentId?: string) {

    switch (toolId.toLocaleLowerCase()) {
        case 'publisher':
            return `/projects/${toolProjectId}/versions/current/categories`;
        case 'players':
            return `/projects/${toolProjectId}/${gameEnvironmentId ? gameEnvironmentId : 'development'}/player`;
        case 'builds':
            return `/projects/${toolProjectId}/builds`;
        case 'portal':
            return `/projects/${toolProjectId}/tools`;
        case 'sessions':
            return `/projects/${toolProjectId}/production/sessions`;
    }
}

export function determineIfPublisherProjectId(projectId?: string) {
    switch (projectId) {
        case '1':
            return 'ppf';
        case '3':
            return 'ppfo';
        case '4':
            return 'dof';
        case '5':
            return 'ykt-bowl';
        default:
            return projectId;
    }
}

export function hostedOnYakOfficeAppUrl(url: string) {
    return !url.match(/yakoffice.app/g);
}

export function validateEmail(email: string) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
}

export function friendlyDate(date: string) {
    return moment(date).format('DD/MM/YYYY');
}
